const isInIframe = (): boolean => window !== window.parent;

export { isInIframe };
